module.exports = __webpack_public_path__ + "static/relaunch-a0b7c728ace08365ea0efbc6c0a8ac78.jpg";